/**
 * Design tokens — aligned with the app's dark editorial system.
 * Used across all Remotion scene compositions.
 */
export const COLORS = {
  bg: '#0A0A0A',
  surface: '#141414',
  card: '#1A1A1A',
  border: 'rgba(255,255,255,0.06)',
  text: {
    primary: '#FFFFFF',
    secondary: '#A1A1A6',
    muted: '#6E6E73',
    dim: '#3A3A3A',
  },
  accent: {
    red: '#FF3B30',
    blue: '#007AFF',
    purple: '#BF5AF2',
    green: '#30D158',
    orange: '#FF9F0A',
    teal: '#5AC8FA',
  },
}

export const FONTS = {
  heading: '"Outfit", "SF Pro Display", system-ui, sans-serif',
  body: '"Inter", "SF Pro Text", system-ui, sans-serif',
  mono: '"JetBrains Mono", "SF Mono", monospace',
}

export const SIZES = {
  width: 1920,
  height: 1080,
}

/* ── Glow presets ─────────────────────────────────────────────────
   Multi-layer box-shadows that simulate bloom / neon glow.
   Usage: boxShadow: GLOW.md('#FF3B30')                         */
export const GLOW = {
  sm: color => `0 0 8px ${color}35, 0 0 16px ${color}18`,
  md: color => `0 0 12px ${color}45, 0 0 28px ${color}22, 0 0 48px ${color}0D`,
  lg: color => `0 0 16px ${color}55, 0 0 36px ${color}2A, 0 0 64px ${color}14, 0 0 90px ${color}08`,
  text: color => `0 0 10px ${color}60, 0 0 30px ${color}30, 0 0 50px ${color}15`,
}

/* ── Glassmorphism presets ────────────────────────────────────────
   Frosted-glass surfaces with backdrop blur.
   Usage: style={{ ...GLASS.card }}                              */
export const GLASS = {
  card: {
    background: 'rgba(26, 26, 26, 0.55)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
  },
  surface: {
    background: 'rgba(20, 20, 20, 0.45)',
    backdropFilter: 'blur(14px)',
    WebkitBackdropFilter: 'blur(14px)',
    border: '1px solid rgba(255, 255, 255, 0.05)',
  },
  chip: {
    background: 'rgba(30, 30, 30, 0.6)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.07)',
  },
}
